// extracted by mini-css-extract-plugin
export var result = "dropResult-module--result--1JGUm";
export var icon = "dropResult-module--icon--3XmAY";
export var name = "dropResult-module--name--3emlG";
export var size = "dropResult-module--size--IGjQT";
export var btn = "dropResult-module--btn--1K5S5";